// extracted by mini-css-extract-plugin
export default {"content":"LogDetail_content__MLLnR","minLabel110":"LogDetail_minLabel110__-qiwc","logTimeRange":"LogDetail_logTimeRange__znC8y"};